export default __webpack_public_path__ + "static/media/Number.6b282284.svg";